import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListWorkProcesses } from "../../../components/Admin/WorkProcesses/ListWorkProcesses/ListWorkProcesses";
import { useLanguage } from "../../../contexts";
import "./WorkProcesses.scss";

export function WorkProcesses() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("actives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListWorkProcesses active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListWorkProcesses active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="work-processes-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="work-processes-page-header-wrapper">
        <div className="work-processes-page-header">
          <span className="work-processes-page-title">{t("work_processes")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
